/**
 * Streamed agent text in, sentences out. The player speaks sentence by sentence, so the first words are heard
 * while the rest is still arriving. A chunk is at least ~40 characters: short fragments ("Thanks.") are joined to
 * what follows, because every chunk is a request and a pause.
 */
export const MIN_CHUNK = 40;
/** After the first chunk, fewer and longer: each chunk is a separate request, and every join is a place the voice
 * can change a little. The first stays short so speech starts early. */
export const LATER_CHUNK = 150;

const BOUNDARY = /[.!?…]["')\]]?\s+/g;

export class SentenceChunker {
  private buffer = "";
  private emitted = 0;
  constructor(private readonly emit: (chunk: string) => void, private readonly first = MIN_CHUNK, private readonly later = LATER_CHUNK) {}

  private get min(): number { return this.emitted ? this.later : this.first; }

  /** Add streamed text; emits every complete sentence run that is long enough. */
  push(delta: string): void {
    this.buffer += delta;
    let cut = -1;
    BOUNDARY.lastIndex = 0;
    for (let m = BOUNDARY.exec(this.buffer); m; m = BOUNDARY.exec(this.buffer)) {
      const end = m.index + m[0].length;
      if (this.buffer.slice(0, end).trim().length >= this.min) cut = end;
    }
    if (cut > 0) {
      const chunk = this.buffer.slice(0, cut).trim();
      this.buffer = this.buffer.slice(cut);
      if (chunk) { this.emitted += 1; this.emit(chunk); }
    }
  }

  /** The turn is finished: whatever is left is spoken, however short. */
  flush(): void {
    const rest = this.buffer.trim();
    this.buffer = "";
    if (rest) this.emit(rest);
  }

  reset(): void { this.buffer = ""; this.emitted = 0; }
}
